import React, {useEffect, useState} from 'react';
import NewsCard from './NewsCard';
import './News.css';
import defaultImage from'./defaultImage.png';

const News = ({dragWidget}) => {

	const [articles, setArticles] = useState([]);


	async function generateNews() {
		try {
			let response = await fetch("https://bing-news-search1.p.rapidapi.com/news?cc=AU&safeSearch=Off&textFormat=Raw", {
				"method": "GET",
				"headers": {
					"x-rapidapi-host": "bing-news-search1.p.rapidapi.com",
					"x-rapidapi-key": "8e491d2c69msh07aad740bbd4da3p181175jsn24cc95163b23",
					"x-bingapis-sdk": "true",
					"x-search-location": "lat: -37.8136, log:144.9631"
				}	
			})
			let data = await response.json();
			setArticles(data.value)
		} catch(e) {
			console.log(e)
		}
	}
	

	useEffect(() => {
		generateNews();

	},[])

	return(
		<div id='news' className='news-container widget' onDoubleClick={dragWidget}>
			{
				articles.map((article, i) => {
					return (
						<NewsCard 
							key={i}
							title={article.name}
							content={article.content}
							author={article.provider[0].name}
							image={ article.image.thumbnail.contentUrl === "" ? defaultImage : article.image.thumbnail.contentUrl } 
							url={article.url}
							publishedAt={article.datePublished}
						/>
					);
				})
			}
		</div>
		);
}

export default News;